import { render } from "./SupportCategories.vue?vue&type=template&id=883c309e&ts=true"
import script from "./SupportCategories.vue?vue&type=script&lang=ts"
export * from "./SupportCategories.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__